import React, { Fragment, useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useAlert } from "react-alert";
import { clearError, getAttributes, updateDiamond, GetProductCount, clearMessage } from "../../actions/productActions";
import { validateFields } from '../../validation';
import classnames from 'classnames';
import { FormattedMessage, useIntl } from 'react-intl';
import $ from 'jquery';
import PopupSucess from '../layout/PopupSucess';
import Loader from '../layout/Loader';
import { getCategory } from '../../actions/categoryAction';
import { url } from '../../config';
import { useLocation } from 'react-router-dom';
import { getLastURL, ImageUrl } from '../../helper';
import { IMAGES } from '../../constants';
import { ExtentionSupport } from '../../utils/json';
import { deleteImage } from '../../utils/CommonApi';
import heic2any from 'heic2any';

const MAX_IMAGE_LIMIT = 5;
//import { Link } from 'react-router-dom';

const Dimonds = () => {
    const dispatch = useDispatch();
    const alert = useAlert();
    const intl = useIntl();
    const location = useLocation();
    const productId = getLastURL(location);
    const { attributes } = useSelector(state => state.attributes);
    const product = useSelector(state => state.productDetails);
    const { updateproduct, error, loading } = useSelector(state => state.updateDiamondReducer);

    useEffect(() => {
        dispatch(getAttributes('diamonds'));
        dispatch(clearMessage());
        dispatch(clearError());
    }, [dispatch])

    const [addproduct, setAddProduct] = useState({
        shape: "",
        id: "",
        category_slug: "",
        carat: "",
        color: "",
        clarity: "",
        cut: "",
        polish: "",
        symmetry: "",
        milky: "",
        availability_status: "",
        bgm: "",
        fluorescence: "",
        table_per: "",
        depth_per: "",
        mm_h: "",
        mm_l: "",
        mm_w: "",
        culet: "",
        certificate: "",
        certificate_number: "",
        discount: "",
        comment: "",
        price: "",
        stock_number: "",
        diamond_3d_link: "",
        fancy_color: "",
        fancy_intensity: "",
        fancy_overtone: "",
        is_fancy: "",
        is_matched_pair: "0",
        pair_stock_no: "",
        is_the_pair_separable: "1",
        images: null,
        video: null,

    })

    /** True when this listing already had a matched partner in DB (pair_stock_no set); pair UI is read-only. */
    const [pairFieldsLocked, setPairFieldsLocked] = useState(false);
    const [checkFancy, setCheckFancy] = useState(false);
    const [images, setImages] = useState([]);
    const [imageToShow, setImageToShow] = useState([]);
    const [video, setVideo] = useState(null);
    const [deleteImgLoader, setDeleteImgLoader] = useState(false);
    const [imgLoading, setImgLoading] = useState(false);
    const fileInputRef = useRef(null);

    const [validerror, setValidError] = useState({
        stock_numberError: "",
        shapeError: "",
        caratError: "",
        colorError: "",
        clarityError: "",
        certificateError: "",
        milkyError: "",
        availabilityStatusError: "",
        priceError: "",
        depth_perError: "",
        mm_l_Error: "",
        mm_h_Error: "",
        mm_w_Error: "",
        table_perError: "",
        pairStockError: "",
        fancy_colorError: "",
    });

    const handleMatchedPairChange = (value) => {
        if (pairFieldsLocked) {
            return;
        }
        setValidError((prev) => ({ ...prev, pairStockError: "" }));
        setAddProduct((prev) => ({
            ...prev,
            is_matched_pair: value,
            pair_stock_no: value === "1" ? prev.pair_stock_no : "",
            is_the_pair_separable: value === "1" ? prev.is_the_pair_separable : "1",
        }));
    };

    const handleSwitchColor = (e) => {
        const isFancy = e.target.checked;
        setCheckFancy(isFancy);
        setValidError((prev) => ({
            ...prev,
            colorError: "",
            fancy_colorError: "",
        }));
        if (isFancy) {
            setAddProduct((prev) => ({
                ...prev,
                is_fancy: 1,
                color: "",
                milky: "",
                bgm: "1",
            }));
        } else {
            setAddProduct((prev) => ({
                ...prev,
                is_fancy: 0,
                fancy_color: "",
                fancy_intensity: "",
                fancy_overtone: "",
            }));
        }
    };

    const handleInputChange = (event) => {
        setValidError({
            stock_numberError: "",
            shapeError: "",
            caratError: "",
            colorError: "",
            clarityError: "",
            certificateError: "",
            milkyError: "",
            availabilityStatusError: "",
            priceError: "",
            depth_perError: "",
            mm_l_Error: "",
            mm_h_Error: "",
            mm_w_Error: "",
            table_perError: "",
            pairStockError: "",
            fancy_colorError: "",
        })
        const newValue = event.target.value;
        // const regex = /^-?[0-9+%.-]*$/;
        // const isValid = regex.test(newValue) && (newValue.match(/-/g) || []).length <= 1 && (newValue.indexOf('-') <= 0);
        // if (isValid) {
        event.target.value = newValue;
        // } else {
        //     event.target.value = '';
        // }

        if (event.target.name == "discount") {
            setAddProduct({ ...addproduct, discount: event.target.value, price: "" })
            if (event.target.value != "") {

                $('.price').attr('readonly', 'readonly');
            } else {

                $('.price').removeAttr('readonly');
            }
        } else if (event.target.name == "price") {
            setAddProduct({ ...addproduct, price: event.target.value, discount: "" })
            if (event.target.value != "") {
                $('.discount').attr('readonly', 'readonly');
            } else {
                $('.discount').removeAttr('readonly');
            }
        } else {
            setAddProduct({ ...addproduct, [event.target.name]: event.target.value })
        }
    }

    const handleStockNumberBlur = () => {
        setAddProduct((prev) => ({
            ...prev,
            stock_number: String(prev.stock_number || "").trim(),
        }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const stockNumberTrimmed = String(addproduct.stock_number || "").trim();
        const stock_numberError = validateFields.validateStock_Number(stockNumberTrimmed);
        const shapeError = validateFields.validateShape(addproduct.shape);
        const caratError = validateFields.validateCarat(addproduct.carat);
        const clarityError = validateFields.validateClarity(addproduct.clarity);
        const certificateError = validateFields.validateCertificate(addproduct.certificate);
        const milkyError = checkFancy
            ? false
            : validateFields.validateMilky(addproduct.milky);
        const availabilityStatusError = validateFields.validateAvailabilityStatus(addproduct.availability_status);
        var priceError = false;
        var mm_l_Error = false;
        var mm_h_Error = false;
        var mm_w_Error = false;
        var table_perError = false;
        var depth_perError = false;

        if (addproduct.mm_l) {
            mm_l_Error = validateFields.validateMm_l(addproduct.mm_l);
        }
        if (addproduct.mm_h) {
            mm_h_Error = validateFields.validateMn_h(addproduct.mm_h);
        }
        if (addproduct.mm_w) {
            mm_w_Error = validateFields.validateMm_w(addproduct.mm_w);
        }
        if (addproduct.table_per) {
            table_perError = validateFields.validateTablePer(addproduct.table_per);
        }
        if (addproduct.depth_per) {
            depth_perError = validateFields.validateDepthPer(addproduct.depth_per);
        }
        if (!addproduct?.discount) {
            priceError = validateFields.validatePrice(addproduct.price);
        }

        let colorError = false;
        let fancy_colorError = false;
        if (!checkFancy) {
            colorError = validateFields.validateColor(addproduct.color);
        } else {
            fancy_colorError = validateFields.validateFancyColor(addproduct.fancy_color);
        }

        let pairStockError = "";
        if (!pairFieldsLocked && addproduct.is_matched_pair === "1") {
            const ps = String(addproduct.pair_stock_no || "").trim();
            const sn = stockNumberTrimmed;
            if (!ps) {
                pairStockError = intl.formatMessage({
                    id: "addsingleproduct.pair-stock-required",
                    defaultMessage:
                        "Please enter the partner stock number for the matched pair.",
                });
            } else if (ps.toLowerCase() === sn.toLowerCase()) {
                pairStockError = intl.formatMessage({
                    id: "addsingleproduct.pair-stock-self",
                    defaultMessage:
                        "Pair stock number cannot be the same as this product's stock number.",
                });
            }
        }

        const buildUpdatePayload = () => {
            const payload = {
                ...addproduct,
                stock_number: stockNumberTrimmed,
                is_fancy: checkFancy ? 1 : 0,
                ...(checkFancy ? { bgm: "1" } : {}),
            };
            const matched = payload.is_matched_pair === "1";
            // is_matched_pair is not a DB column; backend unsets it before update. It must be sent so
            // update-diamond can run pair resolution + fancy match (same as add).
            if (pairFieldsLocked) {
                return payload;
            }
            if (!matched) {
                delete payload.pair_stock_no;
                delete payload.is_the_pair_separable;
                payload.is_matched_pair = "0";
            } else {
                payload.pair_stock_no = String(payload.pair_stock_no || "").trim();
                payload.is_the_pair_separable =
                    payload.is_the_pair_separable === "0" ? "0" : "1";
                payload.is_matched_pair = "1";
            }
            return payload;
        };

        // remove keys with empty value
        const filteredProducts = Object.fromEntries(
            Object.entries(addproduct).filter(([_, value]) => value !== "")
        );

        if (!checkFancy) {
            if ([stock_numberError, shapeError, caratError, colorError, clarityError, certificateError, priceError, availabilityStatusError, milkyError, depth_perError, table_perError, mm_w_Error, mm_l_Error, mm_h_Error].every(e => e === false) && pairStockError === "") {
                setValidError({
                    ...validerror, stock_numberError, shapeError, caratError, colorError, clarityError, certificateError, priceError, availabilityStatusError, milkyError, depth_perError, table_perError, mm_w_Error, mm_l_Error, mm_h_Error, pairStockError: pairStockError || false,
                })

                await dispatch(updateDiamond(buildUpdatePayload()))
            } else {
                setValidError({
                    ...validerror, stock_numberError, shapeError, caratError, colorError, clarityError, certificateError, priceError, availabilityStatusError, milkyError, depth_perError, table_perError, mm_w_Error, mm_l_Error, mm_h_Error, pairStockError: pairStockError || false,
                })
            }
        } else {
            if ([stock_numberError, shapeError, caratError, clarityError, certificateError, priceError, availabilityStatusError, depth_perError, table_perError, mm_w_Error, mm_l_Error, mm_h_Error, fancy_colorError].every(e => e === false) && pairStockError === "") {
                setValidError({
                    ...validerror, stock_numberError, shapeError, caratError, clarityError, certificateError, priceError, availabilityStatusError, depth_perError, table_perError, mm_w_Error, mm_l_Error, mm_h_Error, fancy_colorError, pairStockError: pairStockError || false,
                })

                await dispatch(updateDiamond(buildUpdatePayload()))
            } else {
                setValidError({
                    ...validerror, stock_numberError, shapeError, caratError, clarityError, certificateError, priceError, availabilityStatusError, depth_perError, table_perError, mm_w_Error, mm_l_Error, mm_h_Error, fancy_colorError, pairStockError: pairStockError || false,
                })
            }
        }
        return;
    }

    useEffect(() => {
        if (!updateproduct) {
            return;
        }
        $("#popup-click-sucess").trigger('click');
        dispatch(clearMessage());
        dispatch(GetProductCount());
        dispatch(getCategory());
        setTimeout(() => {
            window.location = url + '/myproducts/diamonds';
        }, 1500);
    }, [updateproduct, dispatch]);

    useEffect(() => {
        if (!error) {
            return;
        }
        const message =
            typeof error === 'string'
                ? error
                : error?.message || 'Something went wrong. Please try again.';
        alert.error(message);
        dispatch(clearError());
    }, [error, dispatch, alert]);

    const convertArrayToFileList = (filesArray) => {
        const dataTransfer = new DataTransfer();
        filesArray?.forEach((fileObj) => dataTransfer?.items?.add(fileObj?.file));
        return dataTransfer?.files;
    };

    useEffect(() => {
        setAddProduct((prev) => ({
            ...prev,
            images: images?.length > 0 ? convertArrayToFileList(images) : null,
        }));
    }, [images]);

    const check_duplicate = (name) => {
        if (images?.length > 0) {
            for (let i = 0; i < images.length; i++) {
                if (images[i]?.name === name) return false;
            }
        }
        if (imageToShow?.length > 0) {
            for (let i = 0; i < imageToShow.length; i++) {
                if (imageToShow[i]?.name === name) return false;
            }
        }
        return true;
    };

    const image_select = async (e) => {
        setImgLoading(true);
        let selectedFiles = e?.target?.files;
        const maxSize = 10 * 1024 * 1024;
        let tempImgArr = [];
        let tempImgArrShow = [];
        let remaining = MAX_IMAGE_LIMIT - imageToShow.length;
        let max_len = selectedFiles?.length > remaining ? remaining : selectedFiles?.length;

        for (let i = 0; i < max_len; i++) {
            let file = selectedFiles[i];
            const fileName = file.name;
            const fileType = fileName?.split('.').pop();

            if (!ExtentionSupport.includes(fileType)) {
                alert.error(fileName + " has an unsupported file format.");
                continue;
            }

            if (file.size > maxSize) {
                alert.error(fileName + " exceeds the 10MB size limit");
                continue;
            }

            if (check_duplicate(fileName)) {
                if (fileType === "heic" || fileType === "heif") {
                    try {
                        const convertedBlob = await heic2any({ blob: file, toType: "image/jpeg" });
                        file = new File([convertedBlob], fileName.replace(/\.(heic|heif)$/i, ".jpg"), { type: "image/jpeg" });
                    } catch (error) {
                        alert.error("Failed to convert HEIC file: " + fileName);
                        continue;
                    }
                }
                tempImgArrShow.push({
                    name: fileName,
                    url: URL.createObjectURL(file),
                    size: file.size,
                    id: "",
                });
                tempImgArr.push({
                    name: fileName,
                    url: URL.createObjectURL(file),
                    file: file,
                    size: file.size,
                });
            } else {
                alert.error(fileName + " is already added to the list");
            }
        }

        setImageToShow((prev) => [...prev, ...tempImgArrShow]);
        setImages((prev) => [...prev, ...tempImgArr]);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
        setImgLoading(false);
    };

    const video_select = (e) => {
        const ext = e?.target?.files[0]?.name.split('.').pop();
        if (ext === 'mp4') {
            const videoUp = e?.target?.files[0];
            setAddProduct((prev) => ({ ...prev, video: videoUp }));
            if (videoUp) {
                const videoUrl = URL.createObjectURL(videoUp);
                setVideo({ url: videoUrl, id: "" });
                const videor = document.getElementById("video");
                if (videor) {
                    let source = videor.querySelector("source");
                    if (!source) {
                        source = document.createElement("source");
                        source.setAttribute("type", "video/mp4");
                        videor.appendChild(source);
                    }
                    source.setAttribute("src", videoUrl);
                    videor.load();
                }
            }
        } else {
            alert.error("Please upload supported file format");
        }
    };

    const deleteImgOrVideo = async (assetId, type) => {
        setDeleteImgLoader(true);
        await deleteImage({ id: assetId, type });
        setDeleteImgLoader(false);
    };

    const delete_image = (index, assetId) => {
        if (assetId) {
            deleteImgOrVideo(assetId, "img");
        }
        const removed = imageToShow[index];
        setImageToShow((prev) => prev.filter((x, i) => i !== index));
        if (removed?.name) {
            setImages((prev) => prev.filter((img) => img.name !== removed.name));
        }
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };

    const delete_video = (assetId) => {
        if (assetId) {
            deleteImgOrVideo(assetId, "video");
        }
        setVideo(null);
        $("#video_upload").val("");
        setAddProduct((prev) => ({ ...prev, video: null }));
    };

    useEffect(() => {
        if (!product?.details?.productDetails || !productId) {
            return;
        }
        const pd = product?.details?.productDetails;
        if (String(pd?.id) !== String(productId)) {
            return;
        }

        if (product?.details?.singleVideo?.video) {
            setVideo({
                url: ImageUrl(product.details.singleVideo.video),
                id: product.details.singleVideo.id,
            });
        } else {
            setVideo(null);
        }

        const imgs = product?.details?.productImages?.map((i) => ({
            url: ImageUrl(i?.file),
            id: i?.id,
        }));
        setImageToShow(imgs || []);
        setImages([]);

        const rawPair = pd?.pair_stock_no;
        const trimmedPair =
            rawPair != null && String(rawPair).trim() !== ""
                ? String(rawPair).trim()
                : "";
        const locked = trimmedPair !== "";
        setPairFieldsLocked(locked);

        let sepStr = "1";
        if (locked) {
            const sep = pd?.is_the_pair_separable;
            if (sep === null || sep === undefined || sep === "") {
                sepStr = "1";
            } else {
                sepStr = Number(sep) === 0 ? "0" : "1";
            }
        }

        const isFancy = String(pd?.is_fancy) === "1" || pd?.is_fancy === 1;
        setCheckFancy(isFancy);

        setAddProduct({
            category_slug: "diamonds",
            id: pd?.id,
            stock_number: pd?.stock_number,
            shape: pd?.shape,
            carat: pd?.carat,
            color: pd?.color,
            clarity: pd?.clarity,
            cut: pd?.cut,
            polish: pd?.polish,
            availability_status: pd?.availability_status && pd?.availability_status.attribute_id,
            milky: pd?.milky && pd?.milky.attribute_id,
            symmetry: pd?.symmetry,
            fluorescence: pd?.a_fluorescence && pd?.a_fluorescence.attribute_id,
            bgm: pd?.bgm && (pd?.bgm == 'Yes' ? '0' : '1'),
            depth: pd?.depth,
            measurement: pd?.measurement,
            culet: pd?.culet,
            certificate: pd?.certificate,
            certificate_number: pd?.certificate_number,
            discount: pd?.discount,
            comment: pd?.comment,
            price: pd?.price,
            mm_w: pd?.mm_w,
            mm_h: pd?.mm_h,
            mm_l: pd?.mm_l,
            table_per: pd?.table_per,
            depth_per: pd?.depth_per,
            diamond_3d_link: pd?.diamond_3d_link,
            fancy_color: pd?.fancy_color,
            fancy_intensity: pd?.fancy_intensity,
            fancy_overtone: pd?.fancy_overtone,
            is_fancy: pd?.is_fancy,
            is_matched_pair: locked ? "1" : "0",
            pair_stock_no: locked ? trimmedPair : "",
            is_the_pair_separable: locked ? sepStr : "1",
        })
    }, [product?.details, productId])

    useEffect(() => {
        if (checkFancy) {
            $('#fancy_color').css({ display: 'block' });
            $('#fancy_color_intensity').css({ display: 'block' });
            $('#fancy_color_overtone').css({ display: 'block' });
            $('#color').css({ display: 'none' });
            $('#discount').css({ display: 'none' });
            $('#white_diamond_milky').css({ display: 'none' });
            $('.white_diamond_bgm').css({ display: 'none' });
        } else {
            $('#fancy_color').css({ display: 'none' });
            $('#fancy_color_intensity').css({ display: 'none' });
            $('#fancy_color_overtone').css({ display: 'none' });
            $('#color').css({ display: 'block' });
            $('#discount').css({ display: 'block' });
            $('#white_diamond_milky').css({ display: 'block' });
            $('.white_diamond_bgm').css({ display: 'block' });
        }
    }, [checkFancy]);

    if (addproduct?.bgm == "1") {
        $("#bgmCheckbox").prop("checked", false);
    } else {
        $("#bgmCheckbox").prop("checked", true);
    }

    const bgmCheckbox = document.getElementById('bgmCheckbox');

    if (bgmCheckbox) {
        bgmCheckbox.addEventListener('change', function () {
            if (this.checked) {
                addproduct.bgm = "0";
            } else {
                addproduct.bgm = "1";
            }
        });
    }

    const pair_stk_number = intl.formatMessage({
        id: "Enter Pair Stock No",
        defaultMessage: "Enter Pair Stock No.",
    });

    return (
        <Fragment>
            {(loading || deleteImgLoader || imgLoading) && <Loader />}
            <Fragment>
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-lg-4">
                            <div className="form-group">
                                <label htmlFor="">
                                    <FormattedMessage
                                        id="addsingleproduct.stockno"
                                        defaultMessage="Stock No."
                                    />
                                    <span className="strike_red">*</span></label>
                                <input type="hidden" name="id" value={addproduct.id} />
                                <input type="hidden" name="category_slug" value="diamonds" />

                                <input
                                    className={classnames("form-control", { 'is-valid': validerror.stock_numberError === false }, { 'is-invalid': validerror.stock_numberError })}
                                    type="text"
                                    placeholder=" Enter Stock No."
                                    onChange={handleInputChange}
                                    onBlur={handleStockNumberBlur}
                                    name="stock_number"
                                    value={addproduct.stock_number}
                                />
                                <p className="invalid-feedback">{validerror.stock_numberError}</p>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="form-group">
                                <label htmlFor="">
                                    <FormattedMessage
                                        id="addsingleproduct.carat"
                                        defaultMessage="Carat"
                                    />
                                    <span className="strike_red">*</span></label>
                                <input type="text" className={classnames("form-control", { 'is-valid': validerror.caratError === false }, { 'is-invalid': validerror.caratError })} placeholder="Enter Carat" name="carat" onChange={handleInputChange} value={addproduct.carat} />
                                <p className="invalid-feedback">{validerror.caratError}</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4">
                            <div className="form-group">
                                <label htmlFor="">
                                    <FormattedMessage
                                        id="addsingleproduct.shape"
                                        defaultMessage="Shape"
                                    />
                                    <span className="strike_red">*</span></label>
                                <select
                                    className={classnames("form-control", { 'is-valid': validerror.shapeError === false }, { 'is-invalid': validerror.shapeError })}
                                    onChange={handleInputChange}
                                    name="shape"
                                    value={addproduct?.shape}>
                                    <FormattedMessage id="addsingleproduct.chooseshape" defaultMessage="Choose">
                                        {(id) => <option value="">{id}</option>}
                                    </FormattedMessage>
                                    {
                                        attributes && attributes.shape && attributes?.shape.map((shape) => {
                                            return (
                                                <option value={shape?.id}>{shape?.name}</option>
                                            )
                                        })
                                    }
                                </select>
                                <p className="invalid-feedback">{validerror.shapeError}</p>
                            </div>
                        </div>
                        <div className="filter_top switch_color">
                            <div className="cus_switch d-flex align-item-center">
                                <p className="font-14 fm black-3B pr-3">
                                    <FormattedMessage
                                        id="addsingleproduct.White"
                                        defaultMessage="White"
                                    />
                                </p>
                                <label className="switch">
                                    <input
                                        type="checkbox"
                                        checked={checkFancy}
                                        onChange={handleSwitchColor}
                                        id="diamond_color"
                                    />
                                    <span className="slider round"></span>
                                </label>
                                <p className="gray-75 font-14 fm pl-3">
                                    <FormattedMessage
                                        id="addsingleproduct.Fancy"
                                        defaultMessage="Fancy"
                                    />
                                </p>
                            </div>
                        </div>
                        <div id="color" className="col-lg-4">
                            <div className="form-group">
                                <label htmlFor="">
                                    <FormattedMessage
                                        id="addsingleproduct.color"
                                        defaultMessage="Color"
                                    />
                                    <span className="strike_red">*</span></label>
                                <select className={classnames("form-control", { 'is-valid': validerror.colorError === false }, { 'is-invalid': validerror.colorError })} onChange={handleInputChange} name="color" value={addproduct?.color}>
                                    <FormattedMessage id="addsingleproduct.choosecolor" defaultMessage="Choose">
                                        {(id) => <option value="">{id}</option>}
                                    </FormattedMessage>
                                    {
                                        attributes && attributes.color && attributes.color.map((color) => {
                                            return (
                                                <option value={color.id}>{color.name}</option>
                                            )
                                        })
                                    }
                                </select>
                                <p className="invalid-feedback">{validerror.colorError}</p>
                            </div>
                        </div>
                        <div id="fancy_color" style={{ display: 'none' }} className="col-lg-4">
                            <div className="form-group">
                                <label htmlFor="">
                                    <FormattedMessage
                                        id="addsingleproduct.fancycolor"
                                        defaultMessage="Fancy Color"
                                    />
                                    <span className="strike_red">*</span>
                                </label>
                                <select className={classnames("form-control", { 'is-valid': validerror.fancy_colorError === false }, { 'is-invalid': validerror.fancy_colorError })} onChange={handleInputChange} name="fancy_color" value={addproduct?.fancy_color}>
                                    <FormattedMessage id="addsingleproduct.choosefancycolor" defaultMessage="Choose">
                                        {(id) => <option value="">{id}</option>}
                                    </FormattedMessage>
                                    {
                                        attributes && attributes.fancy_color && attributes.fancy_color.map((fancy_color) => {
                                            return (
                                                <option value={fancy_color.id}>{fancy_color.name}</option>
                                            )
                                        })
                                    }
                                </select>
                                <p className="invalid-feedback">{validerror.fancy_colorError}</p>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-4" id="fancy_color_intensity" style={{ display: 'none' }}>
                            <div className="form-group">
                                <label htmlFor="">
                                    <FormattedMessage
                                        id="addsingleproduct.fancycolorintensity"
                                        defaultMessage="Fancy Intensity"
                                    />
                                </label>
                                <select
                                    className="form-control"
                                    onChange={handleInputChange}
                                    name="fancy_intensity"
                                    value={addproduct.fancy_intensity}
                                >
                                    <FormattedMessage id="addsingleproduct.choosefancycolorintensity" defaultMessage="Choose">
                                        {(id) => <option value="">{id}</option>}
                                    </FormattedMessage>
                                    {
                                        attributes && attributes.fancy_intensity && attributes.fancy_intensity.map((fancy_intensity) => {
                                            return (
                                                <option value={fancy_intensity.id}>{fancy_intensity.name}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                        </div>

                        <div id="fancy_color_overtone" style={{ display: 'none' }} className="col-lg-4">
                            <div className="form-group">
                                <label htmlFor="">
                                    <FormattedMessage
                                        id="addsingleproduct.fancycolorovertone"
                                        defaultMessage="Fancy Overtone"
                                    />
                                </label>
                                <select className="form-control" onChange={handleInputChange} name="fancy_overtone" value={addproduct.fancy_overtone}>
                                    <FormattedMessage id="addsingleproduct.choosefancycolorovertone" defaultMessage="Choose">
                                        {(id) => <option value="">{id}</option>}
                                    </FormattedMessage>
                                    {
                                        attributes && attributes.fancy_overtone && attributes.fancy_overtone.map((fancy_overtone) => {
                                            return (
                                                <option value={fancy_overtone.id}>{fancy_overtone.name}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-4">
                            <div className="form-group">
                                <label htmlFor="">
                                    <FormattedMessage
                                        id="addsingleproduct.clarity"
                                        defaultMessage="Clarity"
                                    />
                                    <span className="strike_red">*</span></label>
                                <select className={classnames("form-control", { 'is-valid': validerror.clarityError === false }, { 'is-invalid': validerror.clarityError })} onChange={handleInputChange} name="clarity" value={addproduct?.clarity}>
                                    <FormattedMessage id="addsingleproduct.chooseclarity" defaultMessage="Choose">
                                        {(id) => <option value="">{id}</option>}
                                    </FormattedMessage>
                                    {
                                        attributes && attributes.clarity && attributes.clarity.map((clarity) => {
                                            return (
                                                <option value={clarity.id}>{clarity.name}</option>
                                            )
                                        })
                                    }
                                </select>
                                <p className="invalid-feedback">{validerror.clarityError}</p>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="form-group">
                                <label htmlFor="">
                                    <FormattedMessage
                                        id="addsingleproduct.cut"
                                        defaultMessage="Cut"
                                    />
                                </label>
                                <select className="form-control" onChange={handleInputChange} name="cut" value={addproduct?.cut}>
                                    <FormattedMessage id="addsingleproduct.choosecut" defaultMessage="Choose">
                                        {(id) => <option value="">{id}</option>}
                                    </FormattedMessage>
                                    {
                                        attributes && attributes.cut && attributes.cut.map((cut) => {
                                            return (
                                                <option value={cut.id}>{cut.name}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-4">
                            <div className="form-group">
                                <label htmlFor="">
                                    <FormattedMessage
                                        id="addsingleproduct.polish"
                                        defaultMessage="Polish"
                                    />
                                </label>
                                <select className="form-control" onChange={handleInputChange} name="polish" value={addproduct.polish}>
                                    <FormattedMessage id="addsingleproduct.choosepolish" defaultMessage="Choose">
                                        {(id) => <option value="">{id}</option>}
                                    </FormattedMessage>
                                    {
                                        attributes && attributes.polish && attributes.polish.map((polish) => {
                                            return (
                                                <option value={polish.id}>{polish.name}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="form-group">
                                <label htmlFor="">
                                    <FormattedMessage
                                        id="addsingleproduct.symmetry"
                                        defaultMessage="Symmetry"
                                    />
                                </label>
                                <select className="form-control" onChange={handleInputChange} name="symmetry" value={addproduct.symmetry}>
                                    <FormattedMessage id="addsingleproduct.choosesymmetry" defaultMessage="Choose">
                                        {(id) => <option value="">{id}</option>}
                                    </FormattedMessage>
                                    {
                                        attributes && attributes.symmetry && attributes.symmetry.map((symmetry) => {
                                            return (
                                                <option value={symmetry.id}>{symmetry.name}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-4">
                            <div className="form-group">
                                <label htmlFor="">
                                    <FormattedMessage
                                        id="addsingleproduct.fluorescence"
                                        defaultMessage="Fluorescence"
                                    />
                                </label>
                                <select className="form-control" onChange={handleInputChange} name="fluorescence" value={addproduct.fluorescence}>
                                    <FormattedMessage id="addsingleproduct.choosefluorescence" defaultMessage="Choose">
                                        {(id) => <option value="">{id}</option>}
                                    </FormattedMessage>
                                    {
                                        attributes && attributes.fluorescence && attributes.fluorescence.map((flurescence) => {
                                            return (
                                                <option value={flurescence.id} selected="{addproduct.fluorescence}">{flurescence.name}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                        </div>

                        <div className="col-lg-4" id="white_diamond_milky">
                            <div className="form-group">
                                <label htmlFor="">
                                    <FormattedMessage
                                        id="addsingleproduct.milky"
                                        defaultMessage="Milky"
                                    />
                                    <span className="strike_red">*</span>
                                </label>

                                <select className={classnames("form-control milky", { 'is-valid': validerror.clarityError === false }, { 'is-invalid': validerror.milkyError })} onChange={handleInputChange} name="milky" value={addproduct.milky}>
                                    <FormattedMessage id="addsingleproduct.choosemilky" defaultMessage="Choose">
                                        {(id) => <option value="">{id}</option>}
                                    </FormattedMessage>
                                    {
                                        attributes && attributes.milky && attributes.milky.map((milky) => {
                                            return (
                                                <option value={milky.id}>{milky.name}</option>
                                            )
                                        })
                                    }
                                </select>
                                <p className="invalid-feedback">{validerror.milkyError}</p>
                            </div>
                        </div>
                    </div>

                    <div className="row white_diamond_bgm" >
                        <div className="col-lg-1 white_diamond_bgm">
                            <div className="form-group">
                                <label htmlFor="">
                                    <FormattedMessage
                                        id="addsingleproduct.bgm"
                                        defaultMessage="NO BGM"
                                    />
                                    <span className="strike_red">*</span>
                                </label>
                            </div>
                        </div>
                        <div className="col-lg-4 white_diamond_bgm">
                            <div className="cus_switch d-flex align-item-center">
                                {/* <p className="font-14 fm black-3B pr-3"><FormattedMessage
                                    id="addsingleproduct.No"
                                    defaultMessage="No"
                                /></p> */}
                                <label className="switch">
                                    <input type="checkbox" name="bgm" value={addproduct?.bgm} className='bgm' id="bgmCheckbox" />
                                    <span className="slider round"></span>
                                </label>
                                {/* <p className="gray-75 font-14 fm pl-3"> <FormattedMessage
                                    id="addsingleproduct.Yes"
                                    defaultMessage="Yes"
                                /></p> */}
                            </div>
                        </div>
                    </div>

                    <div className="row mt-2">
                        <div className="col-lg-8">
                            <div className="form-group">
                                <div className="d-flex flex-wrap align-items-center">
                                    <label htmlFor="editMatchedPairToggle" className="mb-0 mr-4 mb-md-0 mb-2">
                                        <FormattedMessage
                                            id="addsingleproduct.matched-pair-question"
                                            defaultMessage="Is this a matched pair?"
                                        />
                                    </label>
                                    <div className="cus_switch d-flex align-items-center">
                                        <label className="switch mb-0">
                                            <input
                                                type="checkbox"
                                                id="editMatchedPairToggle"
                                                checked={addproduct.is_matched_pair === "1"}
                                                disabled={pairFieldsLocked}
                                                onChange={(e) =>
                                                    handleMatchedPairChange(e.target.checked ? "1" : "0")
                                                }
                                                aria-label={intl.formatMessage({
                                                    id: "addsingleproduct.matched-pair-question",
                                                    defaultMessage: "Is this a matched pair?",
                                                })}
                                            />
                                            <span className="slider round" />
                                        </label>
                                    </div>
                                </div>
                                {pairFieldsLocked ? (
                                    <small className="form-text text-muted d-block mt-1">
                                        <FormattedMessage
                                            id="addsingleproduct.pair-locked-hint"
                                            defaultMessage="This stone is already linked to a matched pair. Pair stock and separable settings cannot be changed here."
                                        />
                                    </small>
                                ) : null}
                            </div>
                        </div>
                    </div>

                    {addproduct.is_matched_pair === "1" ? (
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="form-group">
                                    <label htmlFor="edit_pair_stock_no_input">
                                        <FormattedMessage
                                            id="addsingleproduct.pair-stock-no"
                                            defaultMessage="Pair stock no"
                                        />
                                        <span className="strike_red">*</span>
                                    </label>
                                    <input
                                        id="edit_pair_stock_no_input"
                                        type="text"
                                        name="pair_stock_no"
                                        disabled={pairFieldsLocked}
                                        className={classnames("form-control", {
                                            "bg-light": pairFieldsLocked,
                                            "is-invalid": validerror.pairStockError,
                                        })}
                                        placeholder={pair_stk_number}
                                        value={addproduct.pair_stock_no}
                                        onChange={handleInputChange}
                                        autoComplete="off"
                                    />
                                    {!pairFieldsLocked ? (
                                        <small className="form-text text-muted">
                                            <FormattedMessage
                                                id="addsingleproduct.pair-stock-hint"
                                                defaultMessage="Enter the stock number of the matching diamond in your inventory."
                                            />
                                        </small>
                                    ) : null}
                                    {validerror.pairStockError ? (
                                        <p className="invalid-feedback d-block">{validerror.pairStockError}</p>
                                    ) : null}
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="form-group">
                                    <label htmlFor="edit_is_the_pair_separable_select">
                                        <FormattedMessage
                                            id="addsingleproduct.is-pair-separable"
                                            defaultMessage="Is the pair separable?"
                                        />
                                    </label>
                                    <select
                                        id="edit_is_the_pair_separable_select"
                                        name="is_the_pair_separable"
                                        disabled={pairFieldsLocked}
                                        className={classnames("form-control", {
                                            "bg-light": pairFieldsLocked,
                                        })}
                                        value={addproduct.is_the_pair_separable}
                                        onChange={handleInputChange}
                                    >
                                        <option value="1">
                                            {intl.formatMessage({
                                                id: "addsingleproduct.Yes",
                                                defaultMessage: "Yes",
                                            })}
                                        </option>
                                        <option value="0">
                                            {intl.formatMessage({
                                                id: "addsingleproduct.No",
                                                defaultMessage: "No",
                                            })}
                                        </option>
                                    </select>
                                    {!pairFieldsLocked ? (
                                        <small className="form-text text-muted">
                                            <FormattedMessage
                                                id="addsingleproduct.is-pair-separable-hint"
                                                defaultMessage="Yes = default."
                                            />
                                        </small>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    ) : null}

                    <div className="row" >
                        <div className="col-lg-4">
                            <div className="form-group">
                                <label htmlFor="">
                                    <FormattedMessage
                                        id="addsingleproduct.status"
                                        defaultMessage="Status"
                                    /><span className="strike_red">*</span>
                                </label>
                                <select className={classnames("form-control", { 'is-valid': validerror.clarityError === false }, { 'is-invalid': validerror.availabilityStatusError })} onChange={handleInputChange} name="availability_status" value={addproduct?.availability_status}>
                                    <FormattedMessage id="addsingleproduct.choose_status" defaultMessage="Choose">
                                        {(id) => <option value="">{id}</option>}
                                    </FormattedMessage>
                                    {
                                        attributes && attributes.availability_status && attributes.availability_status.filter((availability_status) => availability_status.id !== 2321).map((availability_status) => {
                                            return (
                                                <option value={availability_status.id}>{availability_status.name}</option>
                                            )
                                        })
                                    }
                                </select>
                                <p className="invalid-feedback">{validerror.availabilityStatusError}</p>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="form-group">
                                <label htmlFor="">
                                    <FormattedMessage
                                        id="addsingleproduct.measurement"
                                        defaultMessage="Measurement"
                                    />
                                </label>
                                <div className="row">
                                    <div className="col-md-4 mb-md-0 mb-3">
                                        <input type="text" className={classnames("form-control", { 'is-valid': validerror.mm_l_Error === false }, { 'is-invalid': validerror.mm_l_Error })} placeholder="length" name="mm_l" onChange={handleInputChange} value={addproduct?.mm_l} />
                                        <p className="invalid-feedback">{validerror.mm_l_Error}</p>
                                    </div>
                                    <div className="col-md-4 mb-md-0 mb-3">
                                        <input type="text" className={classnames("form-control", { 'is-valid': validerror.mm_w_Error === false }, { 'is-invalid': validerror.mm_w_Error })} placeholder="width" name="mm_w" onChange={handleInputChange} value={addproduct?.mm_w} />
                                        <p className="invalid-feedback">{validerror.mm_w_Error}</p>

                                    </div>
                                    <div className="col-md-4 mb-md-0 mb-0">
                                        <input type="text" className={classnames("form-control", { 'is-valid': validerror.mm_h_Error === false }, { 'is-invalid': validerror.mm_h_Error })} placeholder="depth" name="mm_h" onChange={handleInputChange} value={addproduct?.mm_h} />
                                        <p className="invalid-feedback">{validerror.mm_h_Error}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="row">
                        <div className="col-lg-4">
                            <div className="form-group">
                                <label htmlFor="">
                                    <FormattedMessage
                                        id="addsingleproduct.table"
                                        defaultMessage="Table"
                                    /> %
                                </label>
                                <input type="text" className={classnames("form-control", { 'is-valid': validerror.table_perError === false }, { 'is-invalid': validerror.table_perError })} placeholder="Enter Table %" name="table_per" onChange={handleInputChange} value={addproduct?.table_per} />
                                <p className="invalid-feedback">{validerror.table_perError}</p>

                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="form-group">
                                <label htmlFor="">
                                    <FormattedMessage
                                        id="addsingleproduct.depth"
                                        defaultMessage="Depth"
                                    />
                                    %</label>
                                <input type="text" className={classnames("form-control", { 'is-valid': validerror.depth_perError === false }, { 'is-invalid': validerror.depth_perError })} placeholder="Enter Depth %" name="depth_per" onChange={handleInputChange} value={addproduct.depth_per} />
                                <p className="invalid-feedback">{validerror.depth_perError}</p>
                            </div>
                        </div>

                    </div>

                    <div className="row">
                        <div className="col-lg-4">
                            <div className="form-group">
                                <label htmlFor="">
                                    <FormattedMessage
                                        id="addsingleproduct.certificate"
                                        defaultMessage="Certificate"
                                    />
                                    <span className="strike_red">*</span></label>
                                <select className={classnames("form-control", { 'is-valid': validerror.certificateError === false }, { 'is-invalid': validerror.certificateError })} onChange={handleInputChange} name="certificate" value={addproduct.certificate}>
                                    <FormattedMessage id="addsingleproduct.choosecertificate" defaultMessage="Choose">
                                        {(id) => <option value="">{id}</option>}
                                    </FormattedMessage>
                                    {
                                        attributes && attributes.certificate && attributes.certificate.map((certificate) => {
                                            return (
                                                <option value={certificate.id}>{certificate.name}</option>
                                            )
                                        })
                                    }
                                </select>
                                <p className="invalid-feedback">{validerror.certificateError}</p>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="form-group">
                                <label htmlFor="">
                                    <FormattedMessage
                                        id="addsingleproduct.certificate-no"
                                        defaultMessage="Cetificate No."
                                    />
                                </label>
                                <input
                                    className="form-control"
                                    type="text"
                                    placeholder="Enter Certificate No."
                                    onChange={handleInputChange}
                                    name="certificate_number"
                                    value={addproduct.certificate_number} />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-4" id="discount">
                            <div className="form-group">
                                <label htmlFor="">
                                    <FormattedMessage
                                        id="addsingleproduct.discount"
                                        defaultMessage="Discount"
                                    />
                                    %  <span className="strike_red">*</span></label>
                                <input
                                    className="form-control discount"
                                    type="text"
                                    placeholder="Enter Discount"
                                    onChange={handleInputChange}
                                    name="discount"
                                    value={addproduct?.discount ? addproduct?.discount : ""} />
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="form-group">
                                <label htmlFor="">
                                    <FormattedMessage
                                        id="addsingleproduct.price-ct"
                                        defaultMessage="Price/ct"
                                    />
                                    <span className="strike_red">*</span></label>
                                <input
                                    className={classnames("form-control price", { 'is-valid': validerror?.priceError === false }, { 'is-invalid': validerror?.priceError })}
                                    type="text"
                                    placeholder="Enter Price"
                                    onChange={handleInputChange}
                                    name="price"
                                    value={addproduct?.price ? addproduct?.price : ""} />
                                <p className="invalid-feedback">{validerror?.priceError}</p>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-8">
                            <div className="form-group">
                                <label htmlFor="">
                                    <FormattedMessage
                                        id="addsingleproduct.comment"
                                        defaultMessage="Supplier Comment (optional)"
                                    />
                                </label>
                                <textarea placeholder="Comment" rows="5" className="form-control" onChange={handleInputChange} name="comment" value={addproduct.comment}></textarea>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-8">
                            <div className="form-group">
                                <label htmlFor="">
                                    <FormattedMessage
                                        id="addsingleproduct.add3dlink"
                                        defaultMessage="3d Link"
                                    />
                                </label>
                                <input
                                    className="form-control"
                                    type="text"
                                    placeholder="https://www.v360.in"
                                    value={addproduct?.diamond_3d_link}
                                    onChange={(e) => setAddProduct({ ...addproduct, diamond_3d_link: e?.target?.value })}
                                />
                            </div>
                        </div>
                    </div>

                    <h3 className="forms toBrdr">
                        <FormattedMessage
                            id="addsingleproduct.uploadimage"
                            defaultMessage="Upload Product Photos"
                        />
                        <p>
                            <FormattedMessage
                                id="addsingleproduct.supported-image"
                                defaultMessage="JPEG, PNG supported, max 10mb per image"
                            />
                        </p>
                    </h3>

                    <div className="uploaded-product-grid">
                        <div className="row">
                            {imageToShow?.map((img, key) => (
                                <div className="col-sm-6 col-lg-4 col-xl-3 mb-4" key={img?.id || img?.name || key}>
                                    <div className="imgEdits">
                                        <div className="imgBlock">
                                            <img className="w-100" src={img?.url} alt="" />
                                            <div className="hover">
                                                <img onClick={() => delete_image(key, img?.id)} src={IMAGES.CLOSE_WHITE} alt="" />
                                            </div>
                                        </div>
                                        {img?.size ? (
                                            <div className="col-md-8 pro-ttl-ct">
                                                <h4>{img?.name}</h4>
                                                <p className="mb-10">
                                                    <FormattedMessage
                                                        id="addsingleproduct.ImageUploaded"
                                                        defaultMessage="Image Uploaded"
                                                    /> ({img?.size / 1024}kb)
                                                </p>
                                            </div>
                                        ) : ""}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {imageToShow?.length < MAX_IMAGE_LIMIT ? (
                        <div className="row imgEdits mb-4">
                            <div className="col-md-4">
                                <div className="moreUpload">
                                    <span><img src={IMAGES.DOWNLOAD_SVG} alt="" /></span>
                                    <FormattedMessage
                                        id="addsingleproduct.drop-photo"
                                        defaultMessage="Drop Photos"
                                    />
                                    <input
                                        type="file"
                                        name="Image"
                                        id="image"
                                        multiple
                                        accept=".png,.jpg,.jpeg,.heic,.heif"
                                        onChange={image_select}
                                        ref={fileInputRef}
                                        disabled={imgLoading}
                                    />
                                </div>
                            </div>
                        </div>
                    ) : ""}

                    <h3 className="forms toBrdr">
                        <FormattedMessage
                            id="addsingleproduct.uploadvideo"
                            defaultMessage="Upload Product Video"
                        />
                        <p>
                            <FormattedMessage
                                id="addsingleproduct.Mp4supported"
                                defaultMessage="Mp4 supported"
                            />
                        </p>
                    </h3>

                    {video ? (
                        <div className="col-md-4 imgEdits">
                            <div className="row imgBlock videoEdits mb-4">
                                <div className="close-vid hover">
                                    <img onClick={() => delete_video(video?.id)} src={IMAGES.CLOSE_WHITE} alt="" />
                                </div>
                                <video id="video" style={{ maxWidth: "100%" }}>
                                    <source src={video?.url} type="video/mp4" />
                                    <FormattedMessage
                                        id="addsingleproduct.YourBrowserNotSupport"
                                        defaultMessage="Your browser does not support the video tag."
                                    />
                                </video>
                            </div>
                        </div>
                    ) : (
                        <div className="row imgEdits mb-4 videoUploadDiv">
                            <div className="col-md-4">
                                <div className="moreUpload">
                                    <span><img src={IMAGES.DOWNLOAD_SVG} alt="" /></span>
                                    <FormattedMessage
                                        id="addsingleproduct.drop-videos"
                                        defaultMessage="Drop Video"
                                    />
                                    <input type="file" name="video_upload" id="video_upload" accept=".mp4" onChange={video_select} />
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="row actions my-5">
                        <div className="col-md-6">
                            <button type="submit" className="btn btn-blue mb-2">
                                <FormattedMessage
                                    id="Save"
                                    defaultMessage="Save"
                                />
                            </button>
                        </div>
                    </div>
                </form>
            </Fragment>
            {
                updateproduct &&
                <PopupSucess title={'SUCCESS'} props={String(updateproduct)} />
            }
        </Fragment>
    )
}

export default Dimonds
